
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.855 14.251v9m0-1.5h15a3 3 0 0 0-3-3h-3.75a3 3 0 0 0-3-3H.855m5.25 3h3m3.749-9a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 1 0-4.5 0Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m16.925 16.5.159-1.113A5.946 5.946 0 0 0 19 14.284l1.946.781a1.5 1.5 0 0 0 1.858-.642l.2-.345a1.5 1.5 0 0 0-.373-1.93l-1.633-1.282a5.611 5.611 0 0 0 0-2.231l1.633-1.282A1.5 1.5 0 0 0 23 5.423l-.2-.345a1.5 1.5 0 0 0-1.858-.642L19 5.217a5.946 5.946 0 0 0-1.911-1.1l-.3-2.074A1.5 1.5 0 0 0 15.3.751h-.4a1.5 1.5 0 0 0-1.48 1.287l-.3 2.074a5.941 5.941 0 0 0-1.91 1.1l-1.943-.776a1.5 1.5 0 0 0-1.857.642l-.2.345a1.5 1.5 0 0 0 .372 1.93l1.635 1.282a5.562 5.562 0 0 0 0 2.231l-1.634 1.282","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    